import { useSession } from '@faststore/sdk'
import { List } from '@faststore/ui'
import type { ReactNode } from 'react'
import { useFormattedPrice } from 'src/sdk/product/useFormattedPrice'
import './order-summary.scss'
import OrderSummaryLoyaltyPoints from './OrderSummaryLoyaltyPoints'

interface OrderSummaryProps {
  subTotal: number
  total: number
  numberOfItems: number
  checkoutButton?: ReactNode
  realDiscount: number
  loyaltyPoints: number
}

function OrderSummary({
  total,
  checkoutButton,
  loyaltyPoints,
  realDiscount,
  subTotal,
}: OrderSummaryProps) {
  // TODO: native code of vtex
  // const discount = subTotal - total
  // const formattedDiscount = useFormattedPrice(realDiscount)
  const { person } = useSession()
  const formattedSubtotal = useFormattedPrice(subTotal)
  const formattedRealDiscount = useFormattedPrice(realDiscount)
  const formattedTotal = useFormattedPrice(total)
  const loyaltyPointsText = person?.id ? (
    <p>
      Con questo acquisto accumuli <b>{loyaltyPoints} Punti</b>
    </p>
  ) : (
    <p>
      Con questo acquisto avresti potuto accumulare <b>{loyaltyPoints} Punti</b>
    </p>
  )

  return (
    <>
      <List className="order-summary" data-order-summary>
        {loyaltyPoints > 0 && (
          <li className="mb-4" id="loyalty-points-id">
            <OrderSummaryLoyaltyPoints loyaltyPointsText={loyaltyPointsText} />
          </li>
        )}
        <li className="mb-2">
          <span>Prodotti</span>
          <span>{formattedSubtotal}</span>
        </li>
        {realDiscount > 0 && (
          <li className="mb-2.5">
            <span>Sconti</span>
            <span className="text-red">- {formattedRealDiscount}</span>
          </li>
        )}
        <li className="text__title-subsection">
          <span>Totale Ordine</span>
          <span>{formattedTotal}</span>
        </li>
        {checkoutButton}
      </List>
    </>
  )
}

export default OrderSummary
